import script from "./LanguageConditionField.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageConditionField.vue?vue&type=script&setup=true&lang=js"

import "./LanguageConditionField.vue?vue&type=style&index=0&id=dbb9ab6e&scoped=true&lang=css"

import exportComponent from "/home/dragos/Work/cozmoslabs-ddev/translatepress/wp-content/plugins/translatepress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbb9ab6e"]])

export default __exports__